import { all, call, put } from 'redux-saga/effects'
import get from 'lodash/get'

import { getOpenApiInstance, Response } from '../../api/api'
import { codetableActions } from '../../redux'
import { CodeText } from '../../redux/reducers/codetable/model'
import { ResponseError } from '../../utils/errors'
import { SUPPORTED_EMPLOYMENT_TYPES } from '../../constants/enums'
import { Address } from '../../types/codetable'
import { Action, ExtendedResponse } from '../../types'

// TODO refactor like monodepo
export function* downloadCodetables(): Generator {
  // @ts-ignore
  const [maritalStatuses, countries, employmentTypes, education, housingTypes] = yield all([
    call(getOpenApiInstance().getCodetableMaritalStatuses),
    call(getOpenApiInstance().getCodetableCountries),
    call(getOpenApiInstance().getCodetableEmploymentTypes),
    call(getOpenApiInstance().getCodetableEducation),
    call(getOpenApiInstance().getCodetableHousingTypes),
  ])

  const responses: any = {
    maritalStatuses,
    countries,
    employmentTypes,
    education,
    housingTypes,
  }
  let occupationResponses: any[] = []

  // @ts-ignore
  let all20x: boolean = yield Object.keys(responses).every(
    key => responses[key].responseStatus === Response.ok
  )

  if (all20x) {
    // Process results of the first codetable batch
    const results: any = {}
    Object.keys(responses).map((key: string) => {
      const array: any[] = get(responses[key], 'data.values', [])
      array.sort((a: CodeText, b: CodeText) => a.text.localeCompare(b.text))
      results[key] = array
      return false
    })
    results.employmentTypes = restrictIncomeTypes(results.employmentTypes)

    // Prepare call for the second codetable batch
    const callBatch = results.employmentTypes.map((item: any) =>
      call(getOpenApiInstance().getOccupations, { employmentType: item.code.toString() })
    )
    // @ts-ignore

    occupationResponses = yield all(callBatch)

    // @ts-ignore
    all20x = yield Object.keys(occupationResponses).every(
      // @ts-ignore
      i => occupationResponses[i].responseStatus === Response.ok
    )

    if (all20x) {
      const occupationsByEmploymentType: any = {}
      for (let i = 0; i < occupationResponses.length; i++) {
        const employmentType = results.employmentTypes[i]
        const occupations = get(occupationResponses[i], 'data.occupationList', [])
        occupations.sort((a: CodeText, b: CodeText) => a.text.localeCompare(b.text))
        occupationsByEmploymentType[employmentType.code] = occupations
      }

      results.occupationsByEmploymentType = occupationsByEmploymentType

      yield put(codetableActions.saveCodetables(results))
    }
  }

  if (!all20x) {
    const messageObject = {
      message: 'One of the codetable call failed',
      ...responses,
      occupationResponses,
    }

    throw new ResponseError('codetable - downloadCodetables saga', messageObject)
  }
}

const restrictIncomeTypes = (table: CodeText[]): CodeText[] =>
  table.filter((ct: CodeText): boolean => SUPPORTED_EMPLOYMENT_TYPES.includes(ct.code))

export function* getAddressHints({
  payload: { searchedAddressText, success, error },
}: Action<any>): Generator {
  const response = (yield call(getOpenApiInstance().getAddressHints, {
    addressPart: searchedAddressText,
  })) as ExtendedResponse

  if (response.responseStatus === Response.ok) {
    const addresses: Address[] = get(response, 'data.addresses', [])

    success(addresses)
  } else {
    error()

    throw new ResponseError('codetable - getAddressHints saga', response)
  }
}

export function* getLoanRanges(): Generator {
  const response = (yield call(getOpenApiInstance().getLoanRanges)) as ExtendedResponse

  if (response.responseStatus === Response.ok) {
    const map: any = get(response, 'data.ammountToTermMappings')
    yield put(codetableActions.saveLoanRanges(map))
  } else {
    throw new ResponseError('codetable - getLoanRange saga', response)
  }
}
